<div class="generic-grid" [resBusySpinner]="isBusy" [message]="isBusyMessage"
    [attr.data-automation-id]="automationId + '-container'">
    <div class="header-bar" [ngClass]="[headerTemplate ? 'visible' : 'hidden']"
        [attr.data-automation-id]="automationId + '-button-container'">
        <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
        <button type="button" class="help-button" *ngIf="headerTemplate && helpIndex"
            [attr.data-automation-id]="automationId + '-help-button'" (click)="openHelp()">
            <i class="fa fa-question"></i>
        </button>
    </div>
    <ag-grid-angular #agGrid class="ag-theme-fresh" [ngClass]="[customGridClass ? customGridClass : '']"
        [gridOptions]="gridOptions" [attr.data-automation-id]="automationId + '-grid-container'"
        (cellKeyDown)="onCellKeyDown($event)" [rowDragEntireRow]="rowDragEntireRow"
        [pinnedTopRowData]="pinnedTopRowData" [rowDragManaged]="rowDragManaged"></ag-grid-angular>
    <res-pager #pager *ngIf="pagerVisible"
        [startIndex]="requestInfo && requestInfo.data && requestInfo.data.startIndex ? requestInfo.data.startIndex : 0"
        [totalItems]="totalItems" [loadDataCallback]="loadData.bind(this)"
        [pagerCustomCallback]="gridPagerCustomCallback" [automationId]="automationId + '-pager'"
        [pagerTemplate]="pagerTemplate" [pagerName]="pagerName" [pagerDisabled]="pagerDisabled"
        [isRefreshIconHidden]="isRefreshIconHidden" [pagerAfterLoadCustomCallback]="gridPagerAfterLoadCustomCallback">
        <ng-container *ngTemplateOutlet="pagerTemplate"></ng-container>
    </res-pager>
    <ng-container *ngTemplateOutlet="overlayTemplate"></ng-container>
</div>

<res-context-menu #contextMenu [closeContextMenuEvent]="onContextMenuClose.bind(this)">
</res-context-menu>

<res-context-menu #headerContextMenu>
</res-context-menu>